import HelperMixin from '../../Shared/HelperMixin.vue';

// NOT-11 — Compose + send broadcast notifications. Targets:
//   UserType=null  → all roles
//   UserType=20    → drivers
//   UserType=40    → school admins
//   UserType=70    → parents
//   UserType=80    → riders
// Optional SchoolId scopes the broadcast to a single school cohort.
//
// Hits POST api/admin/Notifications/Broadcast which both writes
// UsersNotifications rows and dispatches FCM device pushes.

export default {
    name: 'AdminNotifications',
    mixins: [HelperMixin],

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        // Audit P1 #5 — Broadcast endpoint scopes school-admins (40/41) to
        // their own school's parents; allow them onto the page.
        if (!this.requireUserType([1, 40, 41])) return;
    },

    data() {
        return {
            Form: {
                Title: '',
                Body: '',
                UserType: null,
                SchoolId: null,
            },
            Sending: false,
            LastResult: null,
        };
    },

    computed: {
        CanSend() {
            return !!this.Form.Title && !!this.Form.Body;
        }
    },

    methods: {
        RoleLabel() {
            const t = this.Form.UserType;
            if (t === null || t === undefined) return 'الكل';
            if (t === 80) return 'الركاب';
            if (t === 20) return 'السائقون';
            if (t === 70) return 'الأهالي';
            if (t === 40) return 'مسؤولو المدارس';
            return 'مخصص';
        },
        ResetForm() {
            this.Form.Title = '';
            this.Form.Body = '';
            this.Form.UserType = null;
            this.Form.SchoolId = null;
            this.LastResult = null;
        },
        async Send() {
            if (!this.CanSend || this.Sending) return;
            this.Sending = true;
            this.LastResult = null;
            try {
                const body = {
                    Title: this.Form.Title,
                    Body: this.Form.Body,
                    UserType: this.Form.UserType,
                    SchoolId: this.Form.SchoolId || null,
                };
                const res = await this.$http.BroadcastAdminNotification(body);
                this.LastResult = {
                    ok: true,
                    notifWritten: res.data?.notifWritten ?? res.data?.NotifWritten ?? 0,
                    fcmDispatched: res.data?.fcmDispatched ?? res.data?.FcmDispatched ?? 0,
                };
            } catch (e) {
                this.LastResult = {
                    ok: false,
                    error: e?.response?.data?.Message || e?.response?.data?.Code || 'فشل الإرسال'
                };
            } finally {
                this.Sending = false;
            }
        }
    }
};
